'use client'

import { resolveFeatures } from '@/src/utils/featureConfig/themeFeatures'
import type { Features } from '@/src/utils/featureConfig'

import { useThemeKey } from './useThemeKey'

// Build-time brand features merged with the per-host theme overlay. Correct during SSR too,
// because the theme key is stamped onto the MUI theme per request — see useThemeKey.
//
// Client components only. Server components use getFeaturesServer() from
// '@/src/utils/server/getFeatures'.
export const useFeatures = (): Partial<Features> => resolveFeatures(useThemeKey())
